import { ReactChild } from 'react';
import { Container, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';

import Footer from 'layouts/common/footer';

const useStyles = makeStyles(() => ({
  loginGrid: {
    padding: '0px !important',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    minHeight: 'calc(100vh - 64px)',
  },
}));

type Props = {
  children: ReactChild;
  hideFooterOnMobile?: boolean;
};

const AuthLayout = ({ children, hideFooterOnMobile = false }: Props) => {
  const classes = useStyles();

  return (
    <Grid container alignItems="center">
      <Grid item xs={12} className={classes.loginGrid}>
        <Container maxWidth="lg" className={classes.loginGrid}>
          {children}
        </Container>
        <Footer hideOnMobile={hideFooterOnMobile} />
      </Grid>
    </Grid>
  );
};

export default AuthLayout;
